export default function () {
    return 'scrollBehavior' in document.documentElement.style;
}
